<template>
    <div>
        <Tab name="2"></Tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <!-- <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.channelName" placeholder="渠道名称" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.trackPath" placeholder="跟踪参数" size="small"></el-input>
                </el-col> -->
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.selectValue" class="input-with-select" size="small">
                        <el-select v-model="params.selectType" slot="prepend" placeholder="请选择">
                            <el-option label="按渠道名称" :value="1"></el-option>
                            <el-option label="按渠道ID" :value="2"></el-option>
                            <el-option label="按跟踪参数" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.accessType" placeholder="请选择" size="small">
                        <el-option label="不限制跟踪对象类型" value=""></el-option>
                        <el-option label="仅看跟踪对象是乐迷的" :value="7"></el-option>
                        <el-option label="仅看跟踪对象是场地的" :value="2"></el-option>
                        <el-option label="仅看跟踪对象是艺人的" :value="1"></el-option>
                        <el-option label="仅看跟踪对象是厂牌的" :value="3"></el-option>
                        <el-option label="仅看跟踪对象是演出的" :value="4"></el-option>
                        <el-option label="仅看跟踪对象是巡演的" :value="5"></el-option>
                        <el-option label="仅看其他跟踪对象" :value="99"></el-option>
                    </el-select>
                </el-col>
                <el-col v-if="params.accessType !== 99" :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
                            <el-option label="按对象ID" :value="1"></el-option>
                            <el-option label="按对象名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.terminal" placeholder="请选择" size="small">
                        <el-option label="不限制访问终端" value=""></el-option>
                        <el-option label="仅看WAP端的访问数据" :value="2"></el-option>
                        <el-option label="仅看WEB端的访问数据" :value="1"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-date-picker
                        v-model="params.startTime"
                        type="date"
                        placeholder="统计起始日期"
                        value-format="yyyy-MM-dd"
                        size="small"
                        :clearable="false"
                        :editable="false">
                    </el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-date-picker
                        v-model="params.endTime"
                        type="date"
                        placeholder="统计结束日期"
                        value-format="yyyy-MM-dd"
                        size="small"
                        :clearable="false"
                        :editable="false">
                    </el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <!-- <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button> -->
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="time" label="日期时间" min-width="150" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="channelName" label="渠道名称" min-width="100" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="trackPath" label="跟踪参数" min-width="100" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="terminal" label="访问终端">
                </el-table-column>
                <el-table-column prop="accessType" label="对象类型">
                </el-table-column>
                <el-table-column prop="accessId" label="对象ID">
                </el-table-column>
                <el-table-column prop="accessUrl" label="访问链接" min-width="180" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="accessUrlPre" label="上个链接" min-width="180" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="accessUrlOriginal" label="来源链接" min-width="180" show-overflow-tooltip>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import Tab from "../components/tab"
const defaultParams = {
    pageNo:1,
    trackPath:"",
    channelName:"",
    queryType: 1,
    queryValue: "",
    startTime:"",
    endTime:"",
    terminal: "",
    accessType: "",
    accessId: "",
    channelId: "",

    selectType: 1,
    selectValue: ''
}
export default {
    components:{Tab},
    data(){
        const endTime = this.$utils.formatDate( (new Date().getTime()), 'yyyy-MM-dd' );
        const startTime = this.$utils.formatDate( (new Date().getTime() - 3600 * 1000 * 24 * 90), 'yyyy-MM-dd' );
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                trackPath: this.$route.query.trackPath || "",
                channelName: this.$route.query.channelName || '',
                startTime:this.$route.query.startTime || startTime,
                endTime:this.$route.query.endTime || endTime,
                queryType:parseInt(this.$route.query.queryType || 1),
                queryValue: this.$route.query.queryValue || "",
                accessType: parseInt(this.$route.query.accessType) || "",
                terminal: parseInt(this.$route.query.terminal) || "",
                channelId: this.$route.query.channelId || "",
                accessId: this.$route.query.accessId || "",

                selectType: this.$route.query.selectType || this.$route.query.channelId ? 2 : 1,
                selectValue: this.$route.query.selectValue || this.$route.query.channelId,
            },
            listLoading: false,
            downLoading: false
        }
    },
    mounted() {
        if( this.params.selectValue ){
            this.getDataList();
        }
    },
    methods:{
        //获取列表
        getDataList() {
            if( !this.params.selectValue ) return;
            const _timeRang = new Date( this.params.endTime ) - new Date( this.params.startTime );
            const _yearRang = parseInt(_timeRang / 24 / 3600 / 1000);
            if( _yearRang > 730 ){
                this.$message.error('目前仅支持最多2年的数据');
                return;
            }    
            if( this.params.selectType == 2 && !/^\d+$/.test(this.params.selectValue) ){
                this.$message.error('请输入正确的渠道ID！');
                return;
            }
            this.listLoading = true;
            this.params = {
                ...this.params,
                channelName: this.params.selectType == 1 ? this.params.selectValue : '',
                channelId: this.params.selectType == 2 ? this.params.selectValue : '',
                trackPath: this.params.selectType == 3 ? this.params.selectValue : '',
                startTime: this.params.startTime + ' 23:59:59',
                endTime: this.params.endTime + ' 00:00:00',
                queryValue: this.params.objectType !== 99 ? this.params.queryValue : ''
            }
            this.$request({
                url: "/report/channel/visitDetailList",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
    }
}
</script>
<style lang="scss" scoped>

</style>